"use strict";
(function(window) {
    window.ObjetMuseeComponent = function() {
        this.initGallery();
    };

    $.extend(window.ObjetMuseeComponent.prototype, {
        initGallery: function () {
            var $galleryContainer = $('.js-gallery');
            if ($galleryContainer.length) {
                $galleryContainer.lightGallery();
            }
            $('.js-gallery-head').on('click', function (event) {
                event.preventDefault();
                $(".js-gallery a:first-child > img").trigger("click");
            })
        }
    });
})(window);

$(document).ready(function() {
    var objetMuseeComponent = new ObjetMuseeComponent();
});
